import React, { useRef } from "react";
import routes from "../routes";
import { Route, Routes } from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import BackToTopButton from "../Components/buttons/BackToTop";

const Public = () => {
  const containerRef = useRef();
  return (
    <main
      ref={containerRef}
      className="w-full h-screen overflow-x-hidden bg-white font-nunito"
    >
      <Navbar />
      <div className="w-full">
        <Routes>
          {routes.map(
            ({ layout, pages }) =>
              layout === "public" &&
              pages.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))
          )}
        </Routes>
      </div>

      <Footer />
    </main>
  );
};

export default Public;
